// The sign-in page's message for a failed sign-in that isn't about one field (Josh, 16 Oct 2026 QA: a failed Google
// sign-in left the page spinning with no message). Field errors return '' because the email form shows those under
// its own fields, and so does closing the Google window yourself, which isn't a failure.
const NO_MESSAGE = [
    'auth/invalid-email', 'auth/user-not-found', 'auth/wrong-password', 'auth/invalid-credential', 'auth/unverified-email',
    'auth/popup-closed-by-user', 'auth/cancelled-popup-request', 'auth/user-cancelled'
];

export default function signinErrorMessage(code) {
    if (code && NO_MESSAGE.indexOf(code) !== -1) return '';
    switch (code) {
    case 'auth/network-request-failed':
        return 'Couldn’t reach Cuelist. Check your connection and try again.';
    case 'auth/popup-blocked':
        return 'The Google sign-in window was blocked. Allow pop-ups for this site and try again.';
    case 'auth/too-many-requests':
        return 'Too many attempts. Wait a few minutes and try again.';
    default:
        return 'Sign-in didn’t work. Please try again, or contact support@thecuelist.com if it keeps happening.';
    }
}

// The message under a field. With email-enumeration protection on, Firebase sends auth/invalid-credential for both a
// wrong password and an unknown email and won't say which (sandbox, 24 Oct 2026), so that one names both.
const FIELD_MESSAGES = {
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-not-found': 'No account found with this email address.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/invalid-credential': 'The email or password is incorrect.',
    'auth/unverified-email': 'Please verify your email address.'
};

export function fieldErrorMessage(code) {
    return FIELD_MESSAGES[code] || 'An error occurred. Please try again.';
}

export function isPasswordFieldError(code) {
    return code === 'auth/wrong-password' || code === 'auth/invalid-credential';
}


// WEBPACK FOOTER //
// ./src/lib/signin-error-message.js